var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"card"},[_c('LoadingIndicator',{staticClass:"card-image",attrs:{"size":"large","icon":_vm.content.image}}),_c('h3',[_vm._v(_vm._s(_vm.content.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }